import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import {ORGANISATION_CONFIG, UPDATE_CONFIG} from './organisationConfig.type';
import organisationConfigService from './organisationConfigService';

const initialState = {
  isLoading: false,
  orgConfig: [] as ORGANISATION_CONFIG[],
};

export const getOrganisationConfig = createAsyncThunk('getOrgConfig', async (payload, thunkAPI) => {
  try {
    const data: AxiosResponse = await organisationConfigService.getOrganisationConfig();
    return data;
  } catch (error) {
    const result = error as AxiosError;
    return thunkAPI.rejectWithValue(result.message);
  }
});

export const updateOrganisationConfig = createAsyncThunk(
  'updateOrgConfig',
  async (values: UPDATE_CONFIG, thunkAPI) => {
    try {
      const data: AxiosResponse = await organisationConfigService.updateOrganisationConfig(values);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const reloadConfig = createAsyncThunk('reloadConfig', async (values, thunkAPI) => {
  try {
    const data: AxiosResponse = await organisationConfigService.reloadConfig();
    return data;
  } catch (error) {
    const result = error as AxiosError;
    return thunkAPI.rejectWithValue(result.message);
  }
});

export const organisationConfigSlice = createSlice({
  name: 'organisationConfig',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getOrganisationConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOrganisationConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      state.orgConfig = action.payload.data;
    });
    builder.addCase(getOrganisationConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.orgConfig = initialState.orgConfig;
      message.error(`${action.payload}`);
    });

    builder.addCase(updateOrganisationConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateOrganisationConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      message.success('Updated Successfully');
    });
    builder.addCase(updateOrganisationConfig.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(reloadConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(reloadConfig.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(reloadConfig.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default organisationConfigSlice.reducer;
